<template>
    <div class="profile">
        <div class="profile__img">
            <div class="profile__bg"></div>
            <template v-if="imgList.length > 0">
                <swiper :spaceBetween="30" :autoplay="{
                                    delay: 3500,
                                    disableOnInteraction: false,
                                    }" :effect="'fade'" :navigation="true" :speed="2000" :modules="modules" class="profileSwiper">
                    <swiper-slide v-for="(i, index) in imgList" :key="i.attachNo">
                        <img :src="`/displayFile.do?attachNo=${i.attachNo}`" :class="`fade-image${index}`" alt="이미지">
                        <!-- <img src="/resource/img/test02.png" alt="이미지"> -->
                    </swiper-slide>
                </swiper>
            </template>
            <div class="none-img" v-else>
                <img src="@/assets/resource/img/doctor_none_img.png" alt="이미지" >
            </div>
            <!-- <div class="profile__img-wrap">
                <template v-if="imgList.length > 0">
                    <img :src="`/displayFile.do?attachNo=${i.attachNo}`" alt="이미지" v-for="i in imgList">
                </template>
            </div> -->
            <!-- 모바일에 노출 -->
            <div class="profile__img-tit">
                <div class="profile__inner">
                    <span class="department-name">{{docDeptNm}}</span>
                    <span class="name">{{info.drName ? info.drName : info.name}} 교수</span>
                    <!-- active 추가 시 하트 변화-->
                    <kr_FavoHeart v-if="favoInfo(info)" :info="favoInfo(info)" />
                </div>
            </div>
        </div>
        <div class="profile__info">
            <div class="profile__inner">
                <div class="profile__info-tit">
                    <span class="department-name">{{docDeptNm}}</span>
                    <span class="name">{{info.drName ? info.drName : info.name}} 교수</span>
                </div>

                <!-- active 추가 시 하트 변화-->
                <kr_FavoHeart v-if="favoInfo(info)" :info="favoInfo(info)" />
            </div>
            <div class="contents profile__cont">
                <div class="profile__top">
                    <div id="diagnosis" class="box pb0">
                        <div class="profile__specialty">
                            <div class="text">
                                <div class="tit">주진료분야</div>
                                <div class="desc">{{info.detailField}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="contents">
                        <div class="box">
                            <div class="profile__specialty">
                                <div class="text">
                                    <div class="profile__tit-box">
                                        <div class="tit">진료일정</div>
                                        <ul class="profile__tit-list">
                                            <li class="profile__tit-item">휴진</li>
                                            <li class="profile__tit-item">예약가능</li>
                                            <li class="profile__tit-item">오전</li>
                                            <li class="profile__tit-item">오후</li>
                                            <li class="profile__tit-item">휴일</li>
                                        </ul>
                                    </div>
                                    <!-- <div class="profile__tit-select">
                                    <select>
                                        <option value="대동맥센터">대동맥센터</option>
                                    </select>
                                </div> -->
                                </div>
                            </div>
                        </div>
                        <kr_Calendar :classList="classList" :reserve="`Y`" :isReserve="$store.getters.getHost != 'H0009' || (info?.appointYn == 'Y' && info?.doctorDept?.rsvYn == 'Y')" @getClass="getDoctorSchedule" />

                        <div class="botton-wrap">
                            <a href="javascript:;" class="main-button c-main" @click="normalReservation(info)" v-if="$store.getters.getHost != 'H0009' || (info?.appointYn == 'Y' && info?.doctorDept?.rsvYn == 'Y')">
                                <img src="@/assets/resource/icon/calender-check.svg" alt="">진료예약
                            </a>
                            <a href="javascript:;" class="main-button c-main" @click="alertTxt" v-else>
                                <img src="@/assets/resource/icon/calender-check.svg" alt="">1666-5000
                            </a>
                            <a href="javascript:;" class="main-button c-sub" @click="showPopup"><img src="@/assets/resource/icon/calender-phone.svg" alt="">간편예약</a>
                            <router-link to="/kr/thanks/register" class="main-button c-gray"><img src="@/assets/resource/icon/calender-love.png" alt="">고맙습니다</router-link>
                        </div>
                    </div>
                </div>
                <div class="box bt" id="education" v-if="record.E">
                    <div class="profile__tit">학력사항</div>
                    <ul class="profile__list">
                        <template v-for="(E, idx) in record.E" :key="E">
                            <li class="profile__item" v-if="idx < record.cnt.E">{{E.title}}</li>
                        </template>
                    </ul>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('E')" @click="more('E')">더보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('E')" @click="less('E')">접기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div class="box" id="education" v-if="record.C">
                    <div class="profile__tit">교육 및 연구경력</div>
                    <ul class="profile__list">
                        <template v-for="(C, idx) in record.C" :key="C">
                            <li class="profile__item" v-if="idx < record.cnt.C">
                                <!-- <div class="tit">{{$commonUtils.makeDateFormat(C.dateData)}}</div> -->
                                <div v-if="C.dateData != '00000000' && C.dateData !== ''">
                                    <div class="tit" v-if="C.dateData == '00000000'"></div>
                                    <div class="tit" v-else-if="C.dateData.substring(0,4) != '0000' && C.dateData.substring(0,4) <= sysYear &&  C.dateData.substring(4, 8) > sysYear">{{C.dateData.substring(0,4)}}~현재</div>
                                    <div class="tit" v-else-if="C.dateData.substring(0,4) == C.dateData.substring(4,8)">{{C.dateData.substring(0, 4)}}</div>
                                    <div class="tit" v-else-if="(C.dateData.substring(0,4) == '0000' && C.dateData.substring(4,8) > sysYear) || (C.dateData.substring(0,4) > sysYear && C.dateData.substring(4,8) == '0000')">현재</div>
                                    <div class="tit" v-else-if="C.dateData.substring(0,4) != '0000' && C.dateData.substring(4,8) == '0000'">{{C.dateData.substring(0,4)}}</div>
                                    <div class="tit" v-else-if="C.dateData.substring(0,4) == '0000' && C.dateData.substring(4,8) != '0000'">{{C.dateData.substring(4,8)}}</div>
                                    <div class="tit" v-else>{{C.dateData.substring(0,4)}}~{{C.dateData.substring(4,8)}}</div>
                                </div>
                                <div class="desc">{{C.title}}</div>
                            </li>
                        </template>
                    </ul>
                    <!-- 수정필요(접기기능 필요없는지...) -->
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('C')" @click="more('C')">더보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('C')" @click="less('C')">접기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div class="box" id="education" v-if="record.A">
                    <div class="profile__tit">수상경력</div>
                    <ul class="profile__list">
                        <template v-for="(A, idx) in record.A" :key="A">
                            <li class="profile__item" v-if="idx < record.cnt.A">
                                <div v-if="A.dateData">{{ A.dateData }}</div>
                                <div class="desc">{{A.title}}</div>
                            </li>
                        </template>
                    </ul>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('A')" @click="more('A')">더보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('A')" @click="less('A')">접기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div class="box" id="education" v-if="record.S">
                    <div class="profile__tit">기타 학술 관련 경력</div>
                    <ul class="profile__list">
                        <template v-for="(S, idx) in record.S">
                            <li class="profile__item" v-if="idx < record.cnt.S" :key="S">
                                <div class="desc" v-if="S.dateData == '00000000'">{{S.title}}</div>
                                <div class="desc" v-else-if="(S.dateData.substring(0, 4) != '0000' && S.dateData.substring(0, 4) <= sysYear) && S.dateData.substring(4, 8) > sysYear">{{S.dateData.substring(0,4)}}~현재 {{S.title}}</div>
                                <div class="desc" v-else-if="S.dateData.substring(0, 4) == S.dateData.substring(4, 8)">{{S.dateData.substring(0,4)}} {{S.title}}</div>
                                <div class="desc" v-else-if="(S.dateData.substring(0, 4) == '0000' && S.dateData.substring(4, 8) > sysYear) || (S.dateData.substring(0, 4) > sysYear && S.dateData.substring(4, 8) == '0000')">현재 {{S.title}}</div>
                                <div class="desc" v-else-if="(S.dateData.substring(0, 4) != '0000' && S.dateData.substring(4, 8) == '0000')">{{S.dateData.substring(0,4)}} {{S.title}}</div>
                                <div class="desc" v-else-if="(S.dateData.substring(0, 4) == '0000' && S.dateData.substring(4, 8) != '0000')">{{S.dateData.substring(4,8)}} {{S.title}}</div>
                                <div class="desc" v-else>{{S.dateData.substring(0,4)}}~{{S.dateData.substring(4,8)}} {{S.title}}</div>
                            </li>
                        </template>
                    </ul>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('S')" @click="more('S')">더보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('S')" @click="less('S')">접기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div class="box" id="book" v-if="record.R">
                    <div class="profile__tit">주요논문</div>
                    <div class="profile__book">
                        <template v-if="info.drSid == 1004945">
                            <a href="https://pubmed.ncbi.nlm.nih.gov/?term=Song+tj%2C+neurology&sort=date" 
                            target="_blank" style="color:#2c6fbb; text-decoration:none;" onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                            https://pubmed.ncbi.nlm.nih.gov/?term=Song+tj%2C+neurology&sort=date</a>
                        </template>
                        <template v-else>
                            <template  v-for="(R, idx) in record.R" :key="R">
                                <p class="desc" v-if="idx < record.cnt.R">{{R.title}}</p>
                            </template>
                        </template>
                    </div>
                     <template v-if="info.drSid != 1004945">
                        <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('R')" @click="more('R')">더보기
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                                <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            </svg>
                        </button>
                        <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('R')" @click="less('R')">접기
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            </svg>
                        </button>
                     </template>
                </div>
                <div class="box revers" id="news" v-if="record.news">
                    <div class="profile__tit">언론보도</div>
                    <ul class="profile__list">
                        <template v-for="(news, idx) in record.news" :key="news">
                            <li class="profile__item" v-if="idx < record.cnt.news" @click="goArticle(news)" style="cursor: pointer;">
                                <div class="tit">{{$commonUtils.dateToStr(news.modifiedDt ? new Date(news.modifiedDt) : new Date(news.createdDt), '.')}}</div>
                                <div class="desc">{{news.title}}</div>
                            </li>
                        </template>
                    </ul>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('news')" @click="more('news')">더보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('news')" @click="less('news')">접기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div class="box revers" id="thank" v-if="record.thanks">
                    <div class="profile__tit">고맙습니다</div>
                    <ul class="profile__list">
                        <template v-for="(thanks, idx) in record.thanks" :key="thanks">
                            <li class="profile__item" v-if="idx < record.cnt.thanks" @click="goArticle(thanks)" style="cursor: pointer;">
                                <div class="tit">{{$commonUtils.dateToStr(thanks.modifiedDt ? new Date(thanks.modifiedDt) : new Date(thanks.createdDt), '.')}}</div>
                                <div class="desc">{{thanks.title}}</div>
                            </li>
                        </template>
                    </ul>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck('thanks')" @click="more('thanks')">더보기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M12.5 5V19" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button href="javascript:;" class="weekly__calendar-btn type2" v-if="expandedCheck_close('thanks')" @click="less('thanks')">접기
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <path d="M5.5 12H19.5" stroke="#111111" stroke-linecap="square" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div class="box" >
                </div>
            </div>
        </div>
        <div class="profile__rnb">
            <ul class="profile__rnb-list">
                <li class="profile__rnb-item diagnosis" :class="{ on: activeSection === 'diagnosis' }">
                    <a href=" javascript:;" @click.prevent="scrollTo('diagnosis')">진료일정</a>
                </li>
                <li class="profile__rnb-item education" :class="{ on: activeSection === 'education' }" v-if="record.A || record.C || record.E || record.S">
                    <a href="javascript:;" @click.prevent="scrollTo('education')">학력&#183;경력</a>
                </li>
                <li class="profile__rnb-item book" :class="{ on: activeSection === 'book' }" v-if="record.R">
                    <a href=" javascript:;" @click.prevent="scrollTo('book')">논문·저서</a>
                </li>
                <li class="profile__rnb-item news" :class="{ on: activeSection === 'news' }" v-if="record.news">
                    <a href=" javascript:;" @click.prevent="scrollTo('news')">언론보도</a>
                </li>
                <li class="profile__rnb-item thank" :class="{ on: activeSection === 'thank' }" v-if="record.thanks">
                    <a href=" javascript:;" @click.prevent="scrollTo('thank')">고맙습니다</a>
                </li>
            </ul>
        </div>
    </div>
    <kr_SimpleRsvPopup :popupVisible="popupVisible" :info="info" @hide-popup="hidePopup" />
</template>



<script>
    import Calendar from '@/components/kr/common/Calendar.vue';
    import { gsap, ScrollTrigger } from "gsap/all";

    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/effect-fade';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { EffectFade, Navigation, Pagination, Autoplay } from 'swiper/modules';
    export default {
        components: {
            Calendar,
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                activeSection: 'diagnosis',
                drSid: this.$route.query.drSid || '',
                deptCd: this.$route.query.deptCd || '',
                info: '',
                schedule: '',
                record: {},
                // 의료진 스케쥴 리스트
                classList: '',
                popupVisible: false,
                imgList: [],
                sysYear: new Date().getFullYear(),
                observer: null,
                docDeptNm: '',
            };
        },
        setup() {
            return {
                modules: [EffectFade, Navigation, Pagination, Autoplay],
            };
        },
        methods: {
            alertTxt(){
                alert('전화 예약 혹은 간편예약을 이용해 주시기 바랍니다.')
            },
            goArticle(article) {
                if (article.linkUrl != '' && article.linkUrl != null) {
                    if (article.linkMethod == '_blank') {
                        window.open(article.linkUrl);
                    } else {
                        location.href = article.linkUrl;
                    }
                } else {
                    this.$router.push({
                        path: `/${this.$store.getters.getLang}/${article.boardId}/view`,
                        query: { boardNo: article.boardNo, articleNo: article.articleNo }
                    });
                }
            },
            favoInfo(info) {
                if (!info) return false
                const obj = {}
                obj.favoYn = info.favoYn == 'Y' ? 'Y' : 'N'
                obj.no = info.drSid
                obj.type = 'DOCTOR'
                obj.doctorDetail = true
                return obj
            },
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            handleIntersection(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.activeSection = entry.target.id;
                        console.log(entry.target.id);
                    }
                });
            },
            // 의사 정보
            getDoctorInfo() {
                const params = {
                    drSid: this.drSid,
                    hospId: this.$store.getters.getHost,
                    langCd: this.$store.getters.getLang
                }
                this.axios.get(`/api/doctorApi/${this.drSid}`, { params: params })
                    .then(res => {
                        const data = res.data
                        this.info = data
                        if (data.attachBag.profile) {
                            this.imgList = data.attachBag.profile
                        }
                        this.docDeptNm = data.deptNm ? data.deptNm : data.mainDeptNm
                        for(let i of data.doctorDeptList){
                            if(i.deptType == 1){
                                console.log(i)
                                this.docDeptNm += this.docDeptNm ? `, ${i.deptNm}` : i.deptNm
                            }
                        }
                    }).catch(err => {
                        console.error(err)
                    })
            },
            getDoctorSchedule(selDt) {
                if (!selDt) {
                    const today = new Date();
                    const year = today.getFullYear();
                    const month = ('0' + (today.getMonth() + 1)).slice(-2);

                    selDt = year + month;
                }
                const param = {
                    hospId: this.$store.getters.getHost,
                    deptCd: this.deptCd,
                    drSid: this.drSid,
                    IN_MED_YM: selDt
                }
                this.axios.get(this.api.doctor.schedule, { params: param })
                    .then(res => {
                        const data = res.data
                        this.schedule = data.schedule
                        if (this.schedule && this.schedule.length > 0) {
                            this.classList = this.schedule.map(i => ({
                                text: i.MED_DT.replaceAll('-', ''),
                                dayType: i.MED_RSV_YN === 'Y' ? 'full' : '',
                                MED_TP: i.MED_TP,
                                NSP_RSN_TP_CD: i.NSP_RSN_TP_CD,
                                HOLY_YN: i.HOLY_YN
                            }))
                        }
                    })
            },
            // 기본정보구분(E:학력/C:경력및연수/A:수상경력/S:학회활동/B:저서/R:논문)
            getDoctorDetail() {
                const param = {
                    drSid: this.drSid,
                    orderBy: 'desc'
                }
                this.axios.get(this.api.doctor.record, { params: param })
                    .then(res => {
                        console.log("record: " + JSON.stringify(res))

                        // 20260121 경력 정렬추가
                        const rows = Array.isArray(res.data) ? [...res.data] : []

                        const gubunSet = new Set()
                        const grouped = rows.reduce((acc, curr) => {
                            const g = curr.gubun
                            gubunSet.add(g)

                            acc[g] = acc[g] || []
                            acc[g].push(curr)

                            acc.cnt = acc.cnt || {}
                            acc.cnt[g] = 5

                            acc.expanded = acc.expanded || {}
                            acc.expanded[g] = acc.expanded[g] || false

                            return acc
                        }, {})

                        // detailSort 오름차순 정렬 (문자열일 수 있으니 숫자로 변환)
                        const toInt = (v) => {
                            const n = parseInt(v, 10)
                            return Number.isFinite(n) ? n : Number.POSITIVE_INFINITY
                        }

                        for (const g of gubunSet) {
                            grouped[g].sort((a, b) => {
                                const da = toInt(a.detailSort)
                                const db = toInt(b.detailSort)
                                // detailSort 같으면 seq로 2차 정렬(안정성)
                                return (da - db) || (toInt(a.seq) - toInt(b.seq))
                            })
                        }
                        this.record = grouped

                        const newsParam = {
                            drSid: this.drSid
                        }
                        this.axios.get(this.api.article.newsList, { params: newsParam })
                            .then(resp => {
                                const newsCnt = resp.data.totCnt
                                if (newsCnt > 0) {
                                    this.record.news = resp.data.list
                                    this.record.cnt.news = 10
                                    this.record.expanded.news = false
                                }

                                const thanksParam = {
                                    refDrSid: this.drSid,
                                    item18: 'O',
                                    hospId: this.$store.state.hospStore.host
                                }

                                this.axios.get(this.api.article.list + '10', { params: thanksParam })
                                    .then(response => {
                                        const thanksCnt = response.data.totCnt
                                        if (thanksCnt > 0) {
                                            this.record.thanks = response.data.list
                                            this.record.cnt.thanks = 10
                                            this.record.expanded.thanks = false
                                        }

                                        this.observeSections()
                                    })
                            })
                    })
            },
            expandedCheck(gubun) {
                return this.record[gubun] && this.record[gubun].length > 5 && !this.record['expanded'][gubun]
            },
            expandedCheck_close(gubun) {
                return this.record[gubun] && 
                    this.record[gubun].length > 5 && 
                    this.record['expanded'][gubun]; // true일 때만 반환
            },
            more(gubun) {
                this.record.cnt[gubun] = this.record[gubun].length
                this.record.expanded[gubun] = true
            },
            less(gubun) {
                this.record.expanded[gubun] = false;
                this.record.cnt[gubun] = 4; // 배열의 길이를 0으로 초기화
            },
            normalReservation(doctor) {
                this.$store.state.reserveStore.normalReserve = doctor
                this.$store.state.patInfoStore = {}
                this.$router.push('/kr/reserve/reservation')
            },
            showPopup() {
                this.popupVisible = true
            },
            hidePopup() {
                this.popupVisible = false
            },
            observeSections() {
                setTimeout(() => {
                    const sections = document.querySelectorAll('#diagnosis, #education, #book, #news, #thank');

                    sections.forEach(section => {
                        if (section) {
                            this.observer.observe(section);
                        }
                    }); 
                }, 100);
            }
        },
        mounted() {
            if (!this.deptCd || !this.drSid) {
                alert("잘못된 접근입니다.")
                this.$router.push('/')
                return
            }

            this.getDoctorInfo()
            this.getDoctorSchedule()
            this.getDoctorDetail()

            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5, // 섹션의 절반 이상이 보일 때 active 설정
            };

            this.observer = new IntersectionObserver(this.handleIntersection, options);
        },
    };
</script>